import OperationalHero from "./OperationalHero";
import OperationalPlanning from "./OperationalPlanning";
import OperationalBenefits from "./OperationalBenefits";
import OperationalCore from "./OperationalCore";

const Operational = () =>
{
    return(
        <>
        <OperationalHero />
        <OperationalPlanning />
        <OperationalBenefits />
        <OperationalCore />
        </>
    );
};

export default Operational;